<template>
 <div  style=" padding:20px;margin-top:10px;background: #fff;  ">
 <el-table v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
    height="660">
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==0" 
      width="5%">
    </el-table-column>
    <el-table-column
      fixed
      prop="create_time"
      label="日期"
      min-width="15%">
    </el-table-column>
    <el-table-column
      prop="sk_name"
      label="服务名称"
      min-width="25%">
    </el-table-column>
    <el-table-column
      prop="sk_amount"
      label="金额"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="pay"
      label="支付状态"
      min-width="10%">
    </el-table-column>	
    <el-table-column
      prop="invoice"
      label="开票状态"
      min-width="10%">
    </el-table-column>
    <el-table-column 
      label="操作"
      min-width="10%">
	  	 <template slot-scope="scope">
				<el-button type="primary" size="small"  v-if="scope.row.pay_status == 0" @click="handlePay()">继续支付</el-button>
				<el-button type="primary" size="small"  v-if="scope.row.pay_status == 2 && scope.row.invoice_status == 0" @click="handleRowEdit(scope.$index, scope.row)">申请开票</el-button>
				<el-button size="small"  v-if="scope.row.invoice_status == 1" @click="handleRowView(scope.$index, scope.row)">查看发票</el-button>
		 </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination> </div>
  </div>
</template>
 
<script>
export default {
    data() {
      return {
	  	page: 1,
		id: 1,
		total: 0,
		size:10,
	    is_loading: false,
		loading: true,
        tableData: [],
      }
    },
    props: {
        titleSync: String,
      },
	  
    methods: {
		handlePageChange(val) {
			this.page = val;
			//保存到localStorage
			localStorage.setItem('adPage', this.page)
			localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
			this.getInfo()
		},
		handleRowEdit(index, row) {
		    localStorage.setItem('orderId', row.id);
			this.$router.push({
					name: 'invoiceApply',
					params: {
					  sometext: ''
					}
				    }); 
         /* this.$emit('update:titleSync', 'invoiceApply');
          
				this.axios.post('https://www.myferp.com/admin/user/invoiceInfo', { id: row.id }).then((response) => {
					console.log(response.data)
					if (response.data.errno === 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});

						this.getList();
					}
				})
          */
 
		},
		handlePay(){
			this.$router.push({
					name: 'payment',
					params: {
					  sometext: ''
					}
				    }); 
		},
		handleRowView(index, row) {
		  localStorage.setItem('invoiceId', 0);
		  localStorage.setItem('orderId', row.id);
		  this.$router.push({
					name: 'invoiceDetail',
					params: {
					  sometext: ''
					}
				    }); 
          /*this.$emit('update:titleSync', 'invoiceDetail');
          
				this.axios.post('https://www.myferp.com/admin/user/invoiceInfo', { id: row.id }).then((response) => {
					console.log(response.data)
					if (response.data.errno === 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});

						this.getList();
					}
				})
          */
 
		},		
	  getInfo(){
 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id; 
		let curPage = that.page;
        console.log( userInfo);  
		  $.ajax({
              type: "GET",
			  data:  {id: info.id, page: curPage, size: 10},
              url: "https://www.myferp.com/admin/user/orderInfo",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.loading = false;
			      that.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        
				console.log(JSON.stringify(data));
				that.tableData = data.data.data ; 
				that.page = data.data.currentPage;
                that.total = data.data.count;
                that.loading = false;				
                }
              });	
	  },
	  routerTo(){
	   // this.$emit('update:titleSync', 'info')
	  
	  },
      onSubmit() { 
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
    computed: {
         
      },	
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/order.vue